export interface Colors {
  colorWhite: string;
  colorLightGrey: string;
  colorGray1: string;
  colorGray2: string;
  colorBlack: string;
  colorFumisGreen1: string;
  colorFumisGreen1Washed: string;
  colorRed: string;
  colorRedWashed: string;
  colorYellow: string;
  colorYellowWashed: string;
  colorBackground: string;
}

export const colors = (): Colors => {
  return {
    colorWhite: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-white')
      ?.trim(),
    colorLightGrey: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-light-grey')
      ?.trim(),
    colorGray1: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-gray-1')
      ?.trim(),
    colorGray2: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-gray-2')
      ?.trim(),
    colorBlack: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-black')
      ?.trim(),
    colorFumisGreen1: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-fumis-green-1')
      ?.trim(),
    colorFumisGreen1Washed: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-fumis-green-1-washed')
      ?.trim(),
    colorRed: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-red')
      ?.trim(),
    colorRedWashed: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-red-washed')
      ?.trim(),
    colorYellow: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-yellow')
      ?.trim(),
    colorYellowWashed: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-yellow-washed')
      ?.trim(),
    colorBackground: getComputedStyle(document.documentElement)
      ?.getPropertyValue('--color-background')
      ?.trim(),
  };
};
